import { createSelector } from "reselect";
const getConfigInfo = (state) => state && state.config;
export const getRequestDetailUrl = createSelector(
    [getConfigInfo],
    (configInfo) =>
        configInfo && configInfo.client && configInfo.client.flowApiUrl
            ? `${configInfo.client.flowApiUrl}api/work-request/`
            : '',
);

export const getRequestbaseUrl = createSelector(
    [getConfigInfo],
    (configInfo) =>
        configInfo && configInfo.client && configInfo.client.flowApiUrl
            ? `${configInfo.client.flowApiUrl}api/`
            : '',
);